module.exports = __webpack_public_path__ + "img/car_00064.02451e3e.jpg";